module.exports = __webpack_public_path__ + "media/domenj/bghead-9a093628.png";